<template>
  <ConfigProvider :locale="locale">
    <div class="demo-app">
      <router-view />
    </div>
  </ConfigProvider>
  </template>
<script lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { computed, defineComponent, ref } from 'vue'
import { useMyStore } from './store'
// import GMap from '/@/components/GMap.vue'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'
import { ConfigProvider } from 'ant-design-vue'
moment.locale('zh-cn')

export default defineComponent({
  name: 'App',
  components: { ConfigProvider },

  setup () {
    const store = useMyStore()
    return {
      locale: zhCN
    }
  }
})
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}
</style>
